import classNames from 'classnames';
import Image from 'next/image';

import { importStatic } from 'utils';

import classes from './stickyFooter.module.css';

interface IProps {
  open: boolean;
  onClose?: () => void;
  children?: JSX.Element;
  scrollUpAnimation?: boolean;
  containerClassName?: string;
}

const StickyFooter = (props: IProps) => {
  const {
    open = false,
    children = null,
    onClose = () => null,
    scrollUpAnimation = false,
    containerClassName = false,
  } = props;

  if (!open) return null;

  return (
    <div
      data-testid="stickyFooter"
      className={classNames(classes.container, containerClassName, {
        [classes.withScrollUpAnimation]: scrollUpAnimation,
      })}
    >
      <div className="d-flex container position-relative">
        {children}
        <div className={classes.closeIcon} onClick={onClose} data-testid="stickyFooterCloseIcon">
          <Image
            width={12}
            height={12}
            alt="Close Icon"
            src={importStatic('/ui-router/images/resume-builder/close-modal.svg')}
          />
        </div>
      </div>
    </div>
  );
};

export default StickyFooter;
